import { render, staticRenderFns } from "./PatientVideo.vue?vue&type=template&id=0c486812&"
import script from "./PatientVideo.vue?vue&type=script&lang=js&"
export * from "./PatientVideo.vue?vue&type=script&lang=js&"
import style0 from "./PatientVideo.vue?vue&type=style&index=0&id=0c486812&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports